import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '/'
  }, {
    name: 'Servicios',
    href: '/servicios'
  }, {
    name: 'Proceso',
    href: '/proceso'
  }, {
    name: 'Resultados',
    href: '/resultados'
  }, {
    name: 'FAQ',
    href: '/faq'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-[#0a0a0a]/80 backdrop-blur-xl border-b border-white/10 py-4 shadow-[0_4px_30px_rgba(0,0,0,0.5)]' : 'bg-transparent border-b border-transparent py-6'}`} data-id="element-161">
      {/* Subtle bottom gradient glow when scrolled */}
      <div className={`absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-brand-emerald/20 to-transparent transition-opacity duration-500 ${isScrolled ? 'opacity-100' : 'opacity-0'}`} data-id="element-162"></div>

      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between relative z-10" data-id="element-163">
        <Link to="/" className="flex items-center gap-2 z-50 relative group" data-id="element-164">
          <div className="absolute inset-0 bg-brand-emerald/20 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-165"></div>
          <img src="https://cdn.magicpatterns.com/uploads/9eqxLFx7HNRwaS7nTrWySg/Captura_de_pantalla_2026-04-28_a_las_19.45.31-removebg-preview.png" alt="Growthly Logo" className="h-7 md:h-9 object-contain relative z-10 filter brightness-0 invert transition-transform duration-300 group-hover:scale-105" data-id="element-166" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-167">
          <div className="flex items-center gap-8 bg-white/5 px-6 py-2.5 rounded-full border border-white/10 backdrop-blur-md shadow-inner" data-id="element-168">
            {navLinks.map(link => {
            const isActive = location.pathname === link.href;
            return <Link key={link.name} to={link.href} className={`text-sm font-medium transition-all duration-300 relative group py-1 ${isActive ? 'text-white' : 'text-gray-400 hover:text-white'}`} data-id="element-169">
                  {link.name}
                  {/* Active Indicator */}
                  {isActive && <motion.span layoutId="navbar-indicator" className="absolute -bottom-2.5 left-1/2 -translate-x-1/2 w-1 h-1 bg-brand-emerald rounded-full shadow-[0_0_10px_rgba(16,185,129,0.8)]" data-id="element-170" />}
                  {/* Hover Indicator */}
                  <span className={`absolute -bottom-1 left-0 h-px bg-brand-emerald/50 transition-all duration-300 ${isActive ? 'w-0' : 'w-0 group-hover:w-full'}`} data-id="element-171"></span>
                </Link>;
          })}
          </div>
          <Link to="/checkout" className="bg-brand-emerald text-white px-6 py-2.5 rounded-full text-sm font-bold hover:bg-brand-emeraldLight transition-all duration-300 shadow-[0_0_20px_rgba(16,185,129,0.3)] hover:shadow-[0_0_30px_rgba(16,185,129,0.5)] hover:-translate-y-0.5 relative overflow-hidden group" data-id="element-172">
            <span className="relative z-10" data-id="element-173">Empezar ahora</span>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-174"></div>
          </Link>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden z-50 p-2 text-gray-300 hover:text-white transition-colors relative" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-175">
          {isMobileMenuOpen ? <X size={24} data-id="element-176" /> : <Menu size={24} data-id="element-177" />}
        </button>

        {/* Mobile Nav */}
        <AnimatePresence data-id="element-178">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="absolute top-0 left-0 right-0 bg-[#0a0a0a]/95 backdrop-blur-xl h-screen pt-24 px-6 flex flex-col gap-6 shadow-2xl border-b border-white/10 lg:hidden" data-id="element-179">
              <div className="absolute inset-0 bg-grid-pattern opacity-20 pointer-events-none" data-id="element-180"></div>
              <div className="flex flex-col gap-2 relative z-10" data-id="element-181">
                {navLinks.map((link, i) => {
              const isActive = location.pathname === link.href;
              return <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: i * 0.1
              }} key={link.name} data-id="element-182">
                      <Link to={link.href} onClick={() => setIsMobileMenuOpen(false)} className={`text-2xl font-bold border-b border-white/5 py-4 transition-colors flex items-center justify-between ${isActive ? 'text-brand-emerald' : 'text-gray-300 hover:text-white'}`} data-id="element-183">
                        {link.name}
                        {isActive && <div className="w-2 h-2 rounded-full bg-brand-emerald shadow-[0_0_10px_rgba(16,185,129,0.8)]" data-id="element-184"></div>}
                      </Link>
                    </motion.div>;
            })}
              </div>
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5
          }} className="relative z-10 mt-8" data-id="element-185">
                <Link to="/checkout" onClick={() => setIsMobileMenuOpen(false)} className="bg-brand-emerald text-white text-center px-6 py-4 rounded-xl text-lg font-bold block shadow-[0_0_30px_rgba(16,185,129,0.3)]" data-id="element-186">
                  Empezar ahora
                </Link>
              </motion.div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}